import { useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import { useOktaAuth } from '@okta/okta-react';
import { captureException } from '@sentry/react';
import { fetchWithAuth } from '../../auth';
import * as ToastConfigs from '../../configs/toast';
import { FileDownloadParams, FileDownloadService, FolderDownloadParams } from '../../services/file-download.service';

export const useRestFileDownload = () => {
  const toast = useToast();
  const { oktaAuth } = useOktaAuth();

  const downloadFile = useCallback(async (params: FileDownloadParams) => {
    try {
      const token = await oktaAuth.getAccessToken();
      
      if (!token) {
        throw new Error('No access token available');
      }

      const blob = await FileDownloadService.downloadFile(params, token, fetchWithAuth);
      FileDownloadService.downloadBlob(blob, params.actualFileName);
    } catch (error) {
      toast(ToastConfigs.problemCompletingRequest);
      captureException(error);
      throw error;
    }
  }, [oktaAuth, toast]);

  const downloadFolder = useCallback(async (params: FolderDownloadParams) => {
    try {
      const token = await oktaAuth.getAccessToken();
      
      if (!token) {
        throw new Error('No access token available');
      }

      await FileDownloadService.downloadFolder(params, token, fetchWithAuth);
    } catch (error) {
      toast(ToastConfigs.problemCompletingRequest);
      captureException(error);
      throw error;
    }
  }, [oktaAuth, toast]);

  return { downloadFile, downloadFolder };
};